<template>
  <header class="mobile-header">
    <div class="header-bar">
      <div class="header-inner">
        <router-link to="/" class="logo" aria-label="무료보험분석 홈">
          <span class="logo-mark">
            <span class="logo-mark-main">무료보험분석</span>
            <span class="logo-mark-sub">FREE INSURANCE CHECK-UP</span>
          </span>
        </router-link>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'MobileHeader'
}
</script>

<style scoped>
.mobile-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.header-bar {
  background: #ffffff;
  border-bottom: 1px solid rgba(20, 45, 133, 0.2);
  transition: background 0.3s ease;
}

.header-inner {
  position: relative;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  text-align: center;
}

.logo {
  display: inline-flex;
  align-items: center;
  margin: 0 auto;
  text-decoration: none;
}

.logo-mark {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  line-height: 1;
}

.logo-mark-main {
  font-family: var(--font-serif-kr, 'Noto Serif KR', serif);
  font-size: 19px;
  font-weight: 700;
  color: var(--le-champagne, #142d85);
  letter-spacing: -0.01em;
}

.logo-mark-sub {
  font-family: var(--font-mono-disp, 'Cinzel', serif);
  font-size: 7.5px;
  font-weight: 500;
  letter-spacing: 0.32em;
  color: var(--le-champagne, #142d85);
  opacity: 0.65;
  /* 자간으로 인한 우측 쏠림 보정 */
  padding-left: 0.32em;
}
</style>
